import { Link } from "react-router";
import { ChevronRight, Home } from "lucide-react";
import { useAssetDetail } from "./use-asset-detail";

// Phase 7 sub-bucket 13. Root → folder-title breadcrumb for the list page
// when scoped to a folder. Reuses the asset detail cache so navigating
// list ↔ detail doesn't refetch the folder title.
export function AssetFolderBreadcrumb({ folderId }: { folderId: string | null }) {
  const detail = useAssetDetail(folderId ?? undefined);

  if (folderId === null) {
    return (
      <nav className="mb-3 flex items-center gap-1 text-sm">
        <span className="inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 font-medium">
          <Home className="h-3.5 w-3.5" />
          Library
        </span>
      </nav>
    );
  }

  return (
    <nav className="mb-3 flex items-center gap-1 text-sm">
      <Link
        to="/admin/content"
        className="inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-muted-foreground hover:bg-muted hover:text-foreground"
      >
        <Home className="h-3.5 w-3.5" />
        Library
      </Link>
      <ChevronRight className="h-3.5 w-3.5 text-muted-foreground" />
      <span className="rounded-md px-1.5 py-0.5 font-medium">
        {detail.data?.asset.title ?? (detail.isLoading ? "…" : "Folder")}
      </span>
    </nav>
  );
}
